import * as i3 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i1$1 from '@angular/common/http';
import { HttpErrorResponse, HTTP_INTERCEPTORS } from '@angular/common/http';
import * as i0 from '@angular/core';
import { Injectable, Component, Input, EventEmitter, Output, NgModule } from '@angular/core';
import * as i4 from '@angular/forms';
import { UntypedFormGroup, UntypedFormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import * as i1 from '@fortawesome/angular-fontawesome';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
function DynamicContentComponent_ng_container_0_p_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "p", 3);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("innerHTML", ctx_r0.content, i0.ɵɵsanitizeHtml);
  }
}
function DynamicContentComponent_ng_container_0_span_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 3);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("innerHTML", ctx_r0.content, i0.ɵɵsanitizeHtml);
  }
}
function DynamicContentComponent_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, DynamicContentComponent_ng_container_0_p_1_Template, 1, 1, "p", 2)(2, DynamicContentComponent_ng_container_0_span_2_Template, 1, 1, "span", 2);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r0.inline);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.inline);
  }
}
function DynamicContentComponent_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 4);
    i0.ɵɵelement(1, "app-load-indicator", 5);
    i0.ɵɵelementEnd();
  }
}
const _c0 = () => ["far", "circle"];
const _c1 = () => ["far", "check-circle"];
const _c2 = a0 => ({
  score: a0
});
function CEQuizComponent_form_0_div_1_div_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 10)(1, "button", 11);
    i0.ɵɵlistener("click", function CEQuizComponent_form_0_div_1_div_4_Template_button_click_1_listener() {
      const answer_r5 = i0.ɵɵrestoreView(_r4).$implicit;
      const question_r6 = i0.ɵɵnextContext().$implicit;
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.setAnswer(question_r6.id, answer_r5.v));
    });
    i0.ɵɵelement(2, "input", 12)(3, "fa-icon", 13)(4, "fa-icon", 14);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const answer_r5 = ctx.$implicit;
    const a_r7 = ctx.index;
    const question_r6 = i0.ɵɵnextContext().$implicit;
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate1("formControlName", "q", question_r6.id, "");
    i0.ɵɵpropertyInterpolate2("id", "q", question_r6.id, "a", a_r7, "");
    i0.ɵɵpropertyInterpolate("value", answer_r5.v);
    i0.ɵɵproperty("checked", ctx_r2.quizForm.get("q" + question_r6.id).value == answer_r5.v);
    i0.ɵɵadvance();
    i0.ɵɵproperty("icon", i0.ɵɵpureFunction0(10, _c0));
    i0.ɵɵadvance();
    i0.ɵɵproperty("icon", i0.ɵɵpureFunction0(11, _c1));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", answer_r5.a, " ");
  }
}
function CEQuizComponent_form_0_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 6)(1, "strong", 7);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 8);
    i0.ɵɵtemplate(4, CEQuizComponent_form_0_div_1_div_4_Template, 6, 12, "div", 9);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const question_r6 = ctx.$implicit;
    const q_r8 = ctx.index;
    i0.ɵɵclassProp("text-danger", question_r6.incorrect);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate2("", q_r8 + 1, ": ", question_r6.question, "");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", question_r6.answers);
  }
}
function CEQuizComponent_form_0_app_dynamic_content_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "app-dynamic-content", 15);
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("blocktitle", "CE Quiz Not Passed")("parameters", i0.ɵɵpureFunction1(2, _c2, ctx_r2.correctPercent));
  }
}
function CEQuizComponent_form_0_app_dynamic_content_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "app-dynamic-content", 16);
  }
  if (rf & 2) {
    i0.ɵɵproperty("blocktitle", "CE Quiz Passed");
  }
}
function CEQuizComponent_form_0_button_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "button", 17);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("disabled", ctx_r2.quizForm.status != "VALID" || ctx_r2.submissionPending);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r2.submissionPending ? "Submitting Quiz" : "Submit Quiz");
  }
}
function CEQuizComponent_form_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "form", 1);
    i0.ɵɵlistener("submit", function CEQuizComponent_form_0_Template_form_submit_0_listener() {
      const courseId_r2 = i0.ɵɵrestoreView(_r1).ngIf;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.submitQuiz(courseId_r2, ctx_r2.quizForm));
    });
    i0.ɵɵtemplate(1, CEQuizComponent_form_0_div_1_Template, 5, 5, "div", 2)(2, CEQuizComponent_form_0_app_dynamic_content_2_Template, 1, 4, "app-dynamic-content", 3)(3, CEQuizComponent_form_0_app_dynamic_content_3_Template, 1, 1, "app-dynamic-content", 4)(4, CEQuizComponent_form_0_button_4_Template, 2, 2, "button", 5);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("formGroup", ctx_r2.quizForm);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r2.questions);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.quizPassed === false);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.quizPassed === true);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.questions.length > 0);
  }
}
function HtmlWidgetComponent_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "div", 2);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("innerHTML", ctx_r0.content, i0.ɵɵsanitizeHtml);
  }
}
function HtmlWidgetComponent_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 3);
    i0.ɵɵelement(1, "app-load-indicator", 4);
    i0.ɵɵelementEnd();
  }
}
export * from '@fortawesome/angular-fontawesome';
import { faSquare, faCheckSquare, faMinusSquare, faCircle, faCheckCircle, faBookmark, faQuestionCircle } from '@fortawesome/free-regular-svg-icons';
import { faMinus, faDollarSign, faShoppingCart, faCheck, faChevronCircleDown, faChevronCircleUp, faTh, faThList, faBookmark as faBookmark$1, faFileInvoice, faUser, faBars, faFilter, faCaretDown, faCaretUp, faUndo, faSpinner, faChevronRight, faChevronUp, faChevronDown, faPlus, faLevelUpAlt, faEllipsisH } from '@fortawesome/free-solid-svg-icons';
import { EMPTY, defer, of, BehaviorSubject, ReplaySubject, interval, combineLatest } from 'rxjs';
import { map, tap, filter, catchError, switchMap } from 'rxjs/operators';
import get from 'lodash/get';
import { SubSink } from 'subsink';
import * as atatus$1 from 'atatus-spa';
class InterceptorUserGatewayService {
  constructor() {}
  static {
    this.ɵfac = function InterceptorUserGatewayService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || InterceptorUserGatewayService)();
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: InterceptorUserGatewayService,
      factory: InterceptorUserGatewayService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(InterceptorUserGatewayService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [], null);
})();
class LmsAppSettings {
  constructor() {
    this.Production = false;
    this.CartHeartbeatDisabled = false;
  }
  static {
    this.ɵfac = function LmsAppSettings_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || LmsAppSettings)();
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: LmsAppSettings,
      factory: LmsAppSettings.ɵfac
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LmsAppSettings, [{
    type: Injectable
  }], null, null);
})();
class Interceptor {
  static {
    this.iugService = null;
  }
  static {
    this.userService = null;
  }
  constructor(iugSvc, LmsAppSettings) {
    this.LmsAppSettings = LmsAppSettings;
    Interceptor.iugService = iugSvc;
  }
  intercept(request, next) {
    let headerBase = {};
    let customRequest;
    if (request.method != "GET" && request.headers.get("Content-Type") == null) {
      headerBase['Content-Type'] = 'application/json';
    }
    if (request.url.startsWith(this.LmsAppSettings.pac_base_nf_url)) {
      /*if(!Interceptor.iugService.UserIsLoggedIn) {
          console.log("Blocking NF request for anonymous", request.url);
          //return EMPTY;
      }*/
      customRequest = request.clone({
        setHeaders: headerBase,
        withCredentials: true
      });
    } else if (request.url.startsWith(this.LmsAppSettings.apiBaseURL)) {
      if (Interceptor.iugService.UserIsLoggedIn && Interceptor.iugService.CSRFToken != null) {
        headerBase['X-CSRF-Token'] = Interceptor.iugService.CSRFToken;
      }
      if (request.url.startsWith(this.LmsAppSettings.apiBaseURL + 'api/lms/course/') && !Interceptor.iugService.UserIsLoggedIn) {
        console.log("Interceptor returning empty", request.url);
        return EMPTY;
      }
      customRequest = request.clone({
        setHeaders: headerBase,
        withCredentials: true
      });
    } else {
      customRequest = request.clone({
        setHeaders: headerBase
      });
    }
    return next.handle(customRequest);
  }
  static {
    this.ɵfac = function Interceptor_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || Interceptor)(i0.ɵɵinject(InterceptorUserGatewayService), i0.ɵɵinject(LmsAppSettings));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: Interceptor,
      factory: Interceptor.ɵfac
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(Interceptor, [{
    type: Injectable
  }], () => [{
    type: InterceptorUserGatewayService
  }, {
    type: LmsAppSettings
  }], null);
})();
class HtmlWidgetContent {
  constructor(source) {
    this.title = undefined;
    this.body = undefined;
    if (source.body) this.body = source.body;
    if (source.title) this.title = source.title;
  }
}
function StripHtml(content) {
  return content.replace(/<[^>]*>/g, '');
}
class LMSContentService {
  constructor(httpClient, LmsAppSettings) {
    this.httpClient = httpClient;
    this.LmsAppSettings = LmsAppSettings;
    this.Cache = {
      HtmlWidgetContents: new Map()
    };
  }
  GetAllContent() {
    if (this.Cache.HtmlWidgetContents.size > 0) {
      return defer(() => of(this.Cache.HtmlWidgetContents));
    }
    return this.httpClient.get(this.LmsAppSettings.apiBaseURL + "api/lms/content").pipe(map(result => {
      let contentMap = new Map();
      Object.keys(result).forEach(contentTitle => {
        let contentObj = typeof result[contentTitle] == "string" ? new HtmlWidgetContent({
          title: contentTitle,
          body: result[contentTitle]
        }) : result[contentTitle];
        if (contentObj == null) contentObj = new HtmlWidgetContent({
          title: contentTitle,
          body: " "
        });
        contentMap.set(contentTitle, contentObj);
      });
      this.Cache.HtmlWidgetContents = contentMap;
      return this.Cache.HtmlWidgetContents;
    }));
  }
  GetContentBlock(ContentTitle) {
    return this.GetAllContent().pipe(tap(allContent => {
      if (window.location.hostname != 'localhost' && !allContent.has(ContentTitle) && typeof atatus != "undefined") {
        atatus.notify(new Error("Missing dynamic content for " + ContentTitle), null, ['DynamicContent']);
      }
    }), map(allContent => allContent.has(ContentTitle) ? allContent.get(ContentTitle).body : ""));
  }
  GetContent(ContentTitle) {
    return this.GetAllContent().pipe(tap(allContent => {
      if (window.location.hostname != 'localhost' && !allContent.has(ContentTitle) && typeof atatus != "undefined") {
        atatus.notify(new Error("Missing dynamic content for " + ContentTitle), null, ['DynamicContent']);
      }
    }), map(allContent => allContent.has(ContentTitle) ? allContent.get(ContentTitle) : ""));
  }
  ReplaceContentTokens(baseContent, parameters, stripHtml = false) {
    if (typeof parameters != "object") parameters = {};
    let replacedContent = baseContent;
    Object.keys(parameters).forEach(key => {
      replacedContent = replacedContent.replace("[[" + key + "]]", parameters[key]);
    });
    if (stripHtml) {
      replacedContent = StripHtml(replacedContent);
    }
    return replacedContent;
  }
  static {
    this.ɵfac = function LMSContentService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || LMSContentService)(i0.ɵɵinject(i1$1.HttpClient), i0.ɵɵinject(LmsAppSettings));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: LMSContentService,
      factory: LMSContentService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LMSContentService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: i1$1.HttpClient
  }, {
    type: LmsAppSettings
  }], null);
})();
class UserCourseDetail {
  constructor(ucdObject) {
    this.Status = "Not Started";
    this.StartDate = undefined;
    this.TranscriptDate = undefined;
    this.CupKey = undefined;
    this.Position = 0;
    this.Evaluated = false;
    this.Favorite = false;
    this.StateApprovalAlert = undefined;
    this.Paid = false;
    if (ucdObject) {
      for (const key in this) {
        if (key in ucdObject) {
          switch (key) {
            case 'Status':
              this.Status = ucdObject[key];
              if ((this.Paid || ucdObject.Paid) && this.Status == "Not Started") {
                this.Status = "Purchased";
              }
              break;
            case 'StartDate':
            case 'TranscriptDate':
              if (ucdObject[key]) {
                if (ucdObject[key].date) {
                  this[key] = new Date(ucdObject[key].date);
                } else if (typeof ucdObject[key] == 'string') {
                  this[key] = new Date(ucdObject[key]);
                }
              }
              break;
            default:
              if (ucdObject[key] != null) {
                this[key] = ucdObject[key];
              }
          }
        }
      }
    }
    if (this.Status == 'CE Earned' && this.TranscriptDate == null) {
      this.TranscriptDate = this.StartDate;
    }
  }
}
class Course {
  constructor(source) {
    this.nid = undefined;
    this.type = undefined;
    this.library = undefined;
    this.title = undefined;
    this.created = undefined;
    this.promote = undefined;
    this.sticky = undefined;
    this.alias = undefined;
    this.typeid = undefined;
    this.approved_states = undefined;
    this.authors = [];
    this.content_length = undefined;
    this.caption_url = undefined;
    this.content_url = undefined;
    this.fallback_content_url = undefined;
    this.course_order_group = undefined;
    this.credits = undefined;
    this.creditNumber = undefined;
    this.description = undefined;
    this.netforum_course_id = undefined;
    this.pass_percentage = undefined;
    this.preview = undefined;
    this.related_bundles = [];
    this.related_courses = [];
    this.splash_image_url = undefined;
    this.subtitle = undefined;
    this.supplementary_materials = undefined;
    this.tags = [];
    this.thumbnail_image_url = undefined;
    this.archived_course = false;
    this.restrictedDataLoaded = false;
    this.permissions = {
      bundles: [],
      roles: []
    };
    this.rights = [];
    this.canAccess = true;
    this.renderOnPage = false;
    this.seo_content_outline = undefined;
    this.seo_content_objectives = undefined;
    this.seo_content_topic_techs = undefined;
    this.seo_content_date = undefined;
    this.seo_content_faq = undefined;
    this.seo_content_reviews = undefined;
    this.canAccess = true;
    this.userData = new UserCourseDetail();
    this.approved_states = "";
    if (source) {
      for (const key in this) {
        if (key in source) {
          switch (key) {
            case 'credits':
              let num = Number(source[key]);
              this.creditNumber = num;
              this[key] = num + ' CE Hour' + (num == 1 ? '' : 's');
              break;
            default:
              if (source[key] != null) {
                this[key] = source[key];
              }
          }
        }
      }
    }
  }
  MakeEmptyCourse() {
    this.title = "";
    this.thumbnail_image_url = "https://learn.cdn.abmp.com/public/ng/emptycourse.png";
    this.course_order_group = {
      order: null,
      name: null,
      background: null
    };
  }
  SetRestrictedData(source) {
    this.restrictedDataLoaded = true;
    if (source) {
      for (const key in source) {
        if (this[key] == null || key == 'rights') {
          switch (key) {
            default:
              this[key] = source[key];
          }
        }
      }
    }
    this.canAccess = this.rights.includes('viewcourse');
  }
  ClearRestrictedData() {
    this.restrictedDataLoaded = false;
    this.rights = ["viewcourse"];
    this.content_url = null;
  }
  MarkInaccessible() {
    this.permissions = {
      bundles: [],
      roles: []
    };
    this.rights = [];
    this.content_url = "";
    this.supplementary_materials = "";
    this.canAccess = false;
  }
  IsCEActive() {
    return get(this, 'userData.Status', '').startsWith('CE ');
  }
}
class CourseBundle {
  constructor(source, lmsDataService) {
    this.title = undefined;
    this.description = undefined;
    this.alias = undefined;
    this.product_code = undefined;
    this.can_access = undefined;
    this.expires = undefined;
    this.can_be_purchased = undefined;
    this.courseIds = undefined;
    this.courses = undefined;
    if (source) {
      for (const key in this) {
        if (key in source) {
          switch (key) {
            case 'courses':
              this[key] = [];
              this.courseIds = [];
              source[key].forEach(courseId => {
                this.courseIds.push(courseId);
                lmsDataService.GetCourse(courseId).subscribe(course => {
                  //Don't push dupe courses in
                  if (course && !this[key].find(c => c.nid == course.nid)) {
                    this[key].push(course);
                  }
                });
              });
              break;
            default:
              this[key] = source[key];
          }
        }
      }
    }
  }
  get Access() {
    return this.can_access ? this.can_access : false;
  }
  set Access(access) {
    this.can_access = access;
  }
  get Expires() {
    return this.expires;
  }
  set Expires(exp) {
    if (!isNaN(Date.parse(exp))) {
      this.expires = new Date(exp);
    }
  }
  get CanPurchase() {
    if (this.Access) return false;
    return this.can_be_purchased;
  }
}
class CourseCarousel {
  constructor(source, allCourses) {
    this.title = undefined;
    this.selector = undefined;
    this.courseIds = [];
    this.courses = [];
    if (source) {
      this.title = source.title;
      this.selector = source.selector;
      this.courseIds = source.courses;
      source.courses.forEach(courseId => {
        this.courses.push(allCourses.find(course => course.netforum_course_id == courseId));
      });
    }
  }
}
class AddCourseFailedException extends Error {}
class DuplicateCourseParticipantException extends Error {}
class MissingPaymentMethodException extends Error {}
class CheckoutException extends Error {}
class CourseNotFoundException extends Error {}
class Message {
  constructor(title, message, level, validFor) {
    this.Id = Math.floor(Math.random() * new Date().getTime());
    this.Title = title;
    this.Message = message;
    this.Level = level ? level : Message.MessageLevel.Info;
    if (validFor > 0) {
      this.Expires = new Date().getTime() + validFor * 1000;
    }
  }
}
(function (Message) {
  let MessageLevel;
  (function (MessageLevel) {
    MessageLevel["Info"] = "success";
    MessageLevel["Warning"] = "warning";
    MessageLevel["Error"] = "danger";
  })(MessageLevel = Message.MessageLevel || (Message.MessageLevel = {}));
  ;
})(Message || (Message = {}));
class MessageBrokerService {
  constructor() {
    this.OnNextMessage = new BehaviorSubject(null).pipe(filter(result => result != null));
  }
  AddMessage(title, message, level, validFor) {
    this.OnNextMessage.next(new Message(title, message, level, validFor));
  }
  AddInfoMessage(title, message, validFor = 0) {
    this.AddMessage(title, message, Message.MessageLevel.Info, validFor);
  }
  AddWarningMessage(title, message, validFor = 0) {
    this.AddMessage(title, message, Message.MessageLevel.Warning, validFor);
  }
  AddErrorMessage(title, message, validFor = 0) {
    this.AddMessage(title, message, Message.MessageLevel.Error, validFor);
  }
  static {
    this.ɵfac = function MessageBrokerService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || MessageBrokerService)();
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: MessageBrokerService,
      factory: MessageBrokerService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MessageBrokerService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [], null);
})();
class LMSDataService {
  constructor(httpClient, messageBrokerService, LmsAppSettings) {
    this.httpClient = httpClient;
    this.messageBrokerService = messageBrokerService;
    this.LmsAppSettings = LmsAppSettings;
    this.courseCountForCarousels = -1;
    this.Authors = new Map();
    this.OnCoursesUpdated = new ReplaySubject();
    this.OnCoursesUpdated.subscribe(courses => this.FetchCarousels(courses));
    this.OnCarouselsUpdated = new ReplaySubject();
    this.OnBundlesUpdated = new ReplaySubject();
    this.FetchCourses();
  }
  FetchCourses() {
    this.httpClient.get(this.LmsAppSettings.apiBaseURL + "api/lms/courses").pipe(map(courseList => {
      let courses = [];
      courseList.forEach(course => {
        course = new Course(course);
        courses.push(course);
      });
      this.OnCoursesUpdated.next(courses);
      this.FetchBundles();
    })).subscribe();
  }
  FetchCarousels(courses) {
    this.httpClient.get(this.LmsAppSettings.apiBaseURL + "api/lms/carousels").pipe(map(carouselList => {
      let carousels = [];
      carouselList.forEach(carousel => {
        carousel = new CourseCarousel(carousel, courses);
        carousels.push(carousel);
      });
      this.OnCarouselsUpdated.next(carousels);
    })).subscribe();
  }
  GetCourse(courseIdOrAlias) {
    return this.OnCoursesUpdated.pipe(map(courses => {
      courses = courses || [];
      let course = courses.find(course => course.netforum_course_id == courseIdOrAlias);
      if (course == null) course = courses.find(course => course.alias == courseIdOrAlias);
      if (course == null) throw new CourseNotFoundException(courseIdOrAlias);
      return course;
    }));
  }
  GetCourseByAlias(alias) {
    return this.OnCoursesUpdated.pipe(map(courses => {
      courses = courses || [];
      return courses.find(course => course.alias == alias);
    }));
  }
  GetAuthor(authorId) {
    if (this.Authors.has(authorId)) {
      return of(this.Authors.get(authorId));
    }
    return this.httpClient.get(this.LmsAppSettings.apiBaseURL + "api/lms/author/" + authorId).pipe(tap(result => this.Authors.set(authorId, result)));
  }
  FetchBundles() {
    this.httpClient.get(this.LmsAppSettings.apiBaseURL + "api/lms/bundles").pipe(catchError(err => {
      if (err.status != 403) {
        if (atatus) {
          atatus.notify(err);
        }
      }
      this.OnBundlesUpdated.next([]);
      return [];
    }), map(bundleList => {
      let bundles = [];
      bundleList.forEach(bundle => {
        bundles.push(new CourseBundle(bundle, this));
      });
      this.OnBundlesUpdated.next(bundles);
    })).subscribe();
  }
  static {
    this.ɵfac = function LMSDataService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || LMSDataService)(i0.ɵɵinject(i1$1.HttpClient), i0.ɵɵinject(MessageBrokerService), i0.ɵɵinject(LmsAppSettings));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: LMSDataService,
      factory: LMSDataService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LMSDataService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: i1$1.HttpClient
  }, {
    type: MessageBrokerService
  }, {
    type: LmsAppSettings
  }], null);
})();
class UserDetail {
  Init() {
    this.ID = 0;
    this.DrupalTokens = {
      CSRF: null,
      Logout: null
    };
    this.Name = {
      first: null,
      last: null,
      preferred: null,
      possessive: null
    };
    this.Courses = {};
    this.Subscriptions = new Map();
    this.Events = new Map();
    this.Roles = [];
    this.FullSSOData = null;
    this.LoginError = null;
  }
  constructor(ssoResponse = null, ssoError = null) {
    if (typeof window == "undefined") {
      this.Init();
      return;
    }
    if (ssoResponse == 'logout' || ssoResponse == 'anonymous') {
      this.Init();
      this.Roles.push('anonymous');
      if (ssoError != null) this.LoginError = ssoError;
      window.localStorage.removeItem('lms-user');
      return;
    }
    if (ssoResponse == null || ssoResponse.current_user == null) {
      this.Init();
      if (window.localStorage['lms-user'] != null) {
        let storedUser = JSON.parse(window.localStorage['lms-user']);
        this.ID = storedUser.ID;
        this.DrupalTokens = storedUser.DrupalTokens;
        this.Name = storedUser.Name;
        this.Roles = storedUser.Roles;
        this.Courses = storedUser.Courses;
        this.Subscriptions = storedUser.Subscriptions instanceof Map ? storedUser.Subscriptions : new Map();
        this.Events = storedUser.Events instanceof Map ? storedUser.Events : new Map();
        this.FullSSOData = storedUser.FullSSOData;
        return;
      }
      return;
    }
    this.ID = ssoResponse.current_user.uid;
    this.Roles = ssoResponse.current_user.roles;
    this.DrupalTokens = {
      CSRF: ssoResponse.csrf_token,
      Logout: ssoResponse.logout_token
    };
    this.Name = {
      first: ssoResponse.pac_sso.Columns.ind_first_name,
      last: ssoResponse.pac_sso.Columns.ind_last_name,
      preferred: ssoResponse.pac_sso.Columns.ind_badge_name ? ssoResponse.pac_sso.Columns.ind_badge_name : ssoResponse.pac_sso.Columns.ind_first_name,
      possessive: ""
    };
    this.Name.possessive = this.Name.preferred + "'" + (this.Name.preferred.endsWith('s') ? '' : 's');
    this.Courses = ssoResponse.pac_lms.courses;
    this.Subscriptions = new Map();
    if (ssoResponse.pac_sso.Collections.OrganizationSubscriptions) {
      ssoResponse.pac_sso.Collections.OrganizationSubscriptions.forEach(ivd => {
        this.Subscriptions.set(ivd.Columns.prd_code, ivd.Columns);
      });
    }
    ssoResponse.pac_sso.Collections.InvoiceDetailTerm.forEach(ivd => {
      this.Subscriptions.set(ivd.Columns.prd_code, ivd.Columns);
    });
    this.Events = new Map();
    if (ssoResponse.pac_sso.Collections.EventsRegistrant) {
      ssoResponse.pac_sso.Collections.EventsRegistrant.forEach(evt => {
        this.Events.set(evt.Columns.evt_code, evt.Columns);
      });
    }
    this.FullSSOData = ssoResponse;
    window.localStorage['lms-user'] = JSON.stringify(this);
  }
  get IsLoggedIn() {
    return this.ID > 0;
  }
  GetApprovalStates() {
    if (this.FullSSOData && this.FullSSOData.pac_lms && this.FullSSOData.pac_lms.approval_states) {
      return this.FullSSOData.pac_lms.approval_states.sort();
    }
    return [];
  }
  GetCourseData(courseId) {
    console.error("Move to user-course-data service");
    let courseData = {
      Status: "Not Started",
      Position: 0,
      CupKey: null,
      StartDate: null,
      TranscriptDate: null,
      StateApprovalAlert: "",
      Favorite: false,
      Evaluated: false
    };
    if (!(this.Courses == null || this.Courses[courseId] == null)) {
      courseData = this.Courses[courseId];
    }
    return courseData;
  }
  GetMemberTypes(association) {
    let mbtCodes = [];
    if (this.FullSSOData) {
      this.FullSSOData.pac_sso.Collections.Membership.forEach(mbr => {
        if (mbr.Columns.mbr_asn_code.toLowerCase() == association.toLowerCase()) {
          let dateCheck = new Date();
          dateCheck.setDate(dateCheck.getDate() - 1);
          if (mbr.Columns.mbr_expire_date && new Date() < dateCheck) return;
          if (mbr.Columns.mbr_terminate_date && new Date(mbr.Columns.mbr_terminate_date) < dateCheck) return;
          mbtCodes.push(mbr.Columns.mbt_code);
        }
      });
    }
    if (mbtCodes.length == 0 && this.ID != 0) {
      mbtCodes.push("Non-Member");
    }
    return mbtCodes;
  }
  CheckMemberGroup(association, group) {
    let mbtCodes = this.GetMemberTypes(association);
    switch (group) {
      case 'CPP':
        return mbtCodes.includes('Certified') || mbtCodes.includes('Professional') || mbtCodes.includes('Practitioner');
        break;
      case 'CPPA':
        return mbtCodes.includes('Certified') || mbtCodes.includes('Professional') || mbtCodes.includes('Practitioner') || mbtCodes.includes('Associate');
        break;
      case 'StudentFSN':
        return mbtCodes.includes('Student') || mbtCodes.includes('Free Network');
        break;
    }
    return false;
  }
}
class LmsUserService {
  constructor(httpClient, messageBrokerService, iugService, LmsAppSettings) {
    this.httpClient = httpClient;
    this.messageBrokerService = messageBrokerService;
    this.iugService = iugService;
    this.LmsAppSettings = LmsAppSettings;
    this.OnUserStateChange = new BehaviorSubject(new UserDetail(null));
    this._user = new UserDetail(null);
    this.GetUserInfo(null);
    this.OnUserStateChange.subscribe(user => {
      this.iugService.UserIsLoggedIn = user.IsLoggedIn;
      if (user.DrupalTokens && user.DrupalTokens.CSRF) {
        this.iugService.CSRFToken = user.DrupalTokens.CSRF;
      }
    });
    this.UpdateSessionToken();
    interval(60000).subscribe(() => {
      this.UpdateSessionToken();
    });
  }
  UpdateSessionToken() {
    this.httpClient.get(this.LmsAppSettings.apiBaseURL + "session/token", {
      responseType: 'text'
    }).subscribe(tokenResponse => {
      console.log('Session token updated: ' + tokenResponse);
      this.iugService.CSRFToken = tokenResponse;
    });
  }
  get User() {
    return this._user;
  }
  get IsLoggedIn() {
    return this.User.ID != 0;
  }
  Login(username, password) {
    let data = {
      username: username,
      password: password
    };
    return this.httpClient.post(this.LmsAppSettings.apiBaseURL + "sso", data).pipe(catchError((err, caught) => {
      return this.HandleSSOError(err, caught);
    }), map(loginResult => {
      if (loginResult.LoginError != null) {
        return loginResult;
      } else {
        let userDetails = new UserDetail(loginResult);
        this.GetUserInfo(loginResult);
        this.OnUserStateChange.next(userDetails);
        return userDetails;
      }
    }));
  }
  LoginToken(token) {
    return this.httpClient.get(this.LmsAppSettings.apiBaseURL + "sso/" + token).pipe(catchError((err, caught) => {
      return this.HandleSSOError(err, caught);
    }), map(loginResult => {
      if (loginResult.LoginError != null) {
        return loginResult;
      } else {
        let userDetails = new UserDetail(loginResult);
        this.GetUserInfo(loginResult);
        this.OnUserStateChange.next(userDetails);
        return userDetails;
      }
    }));
  }
  Logout() {
    this.httpClient.post(this.LmsAppSettings.apiBaseURL + "user/logout?_format=json&token=" + this.User.DrupalTokens.Logout, {}).pipe(tap(loginResult => {
      let anon = new UserDetail('anonymous');
      this.OnUserStateChange.next(anon);
      this.messageBrokerService.AddInfoMessage("Logout complete", "You have successfully logged out", 10);
      this.GetUserInfo('logout');
    })).subscribe();
  }
  GetUserInfo(ssoResponse) {
    if (ssoResponse != null) {
      let userDetails = ssoResponse.constructor.name == 'UserDetail' ? ssoResponse : new UserDetail(ssoResponse);
      this._user = userDetails;
      if (userDetails.FullSSOData && userDetails.FullSSOData.pac_sso && typeof atatus != 'undefined') {
        atatus.setUser(userDetails.FullSSOData.pac_sso.Columns.cst_recno, userDetails.FullSSOData.pac_sso.Columns.eml_address, userDetails.FullSSOData.pac_sso.Columns.ind_full_name_cp);
      }
      this.OnUserStateChange.next(userDetails);
      return;
    }
    this.httpClient.get(this.LmsAppSettings.apiBaseURL + "sso").pipe(catchError((err, caught) => this.HandleSSOError(err, caught)), tap(ssoResponse => {
      let userDetails = ssoResponse.constructor.name == 'UserDetail' ? ssoResponse : new UserDetail(ssoResponse);
      this._user = userDetails;
      if (userDetails.FullSSOData && userDetails.FullSSOData.pac_sso && typeof atatus != 'undefined') {
        atatus.setUser(userDetails.FullSSOData.pac_sso.Columns.cst_recno, userDetails.FullSSOData.pac_sso.Columns.eml_address, userDetails.FullSSOData.pac_sso.Columns.ind_full_name_cp);
      }
      this.OnUserStateChange.next(userDetails);
    })).subscribe();
  }
  HandleSSOError(error, caught) {
    let loginError = "";
    if (error.status == 401 && error.error && error.error.message && error.error.message == 'Login Required') {
      return of(new UserDetail('anonymous'));
    }
    if (error.status == 401 && error.error && error.error.message && error.error.message == 'LoginByCookie failed') {
      return of(new UserDetail('anonymous', 'LoginByCookie failed'));
    }
    if (error.status != 401) {
      loginError = "We had a problem logging you in. Please try again.";
    }
    if (error.error.message == null) {
      error.error.message == '';
    }
    switch (error.error.message) {
      case "LoginByEmail Failed":
        loginError = "Sorry, unrecognized email address or password";
        break;
    }
    return of(new UserDetail('anonymous', loginError));
  }
  static {
    this.ɵfac = function LmsUserService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || LmsUserService)(i0.ɵɵinject(i1$1.HttpClient), i0.ɵɵinject(MessageBrokerService), i0.ɵɵinject(InterceptorUserGatewayService), i0.ɵɵinject(LmsAppSettings));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: LmsUserService,
      factory: LmsUserService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LmsUserService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: i1$1.HttpClient
  }, {
    type: MessageBrokerService
  }, {
    type: InterceptorUserGatewayService
  }, {
    type: LmsAppSettings
  }], null);
})();
class CartDetails {
  constructor() {
    this.Subtotal = 0;
    this.Discount = 0;
    this.Total = 0;
    this.Courses = new Map();
    this.Subscriptions = new Map();
    this.Discounts = [];
    this.PendingItems = new Set();
  }
  get ItemArray() {
    let arr = [...Array.from(this.Courses.values()), ...Array.from(this.Subscriptions.values())];
    arr.sort((a, b) => {
      if (a.Item.title > b.Item.title) return 1;
      if (a.Item.title < b.Item.title) return -1;
      return 0;
    });
    return arr ? arr : [];
  }
}
class NetforumInvoice {
  constructor(source) {
    this.inv_key = undefined;
    this.inv_code = undefined;
    this.inv_trx_date = undefined;
    this.inv_close_flag = undefined;
    this.inv_subtotal = undefined;
    this.inv_discount = undefined;
    this.inv_total = undefined;
    this.HasCELines = false;
    this.InvoiceDetails = [];
    this.AdditionalInvoiceDetails = [];
    if (source) {
      for (const key in this) {
        if (key in source) {
          switch (key) {
            case 'inv_trx_date':
              if (source[key]) {
                if (source[key].date) {
                  this[key] = new Date(source[key].date);
                } else if (typeof source[key] == 'string') {
                  this[key] = new Date(source[key]);
                }
              }
              break;
            case 'InvoiceDetails':
              source.InvoiceDetails.forEach(ivd => {
                if (ivd.ptp_code == 'Course Fee' || ivd.ptp_code == 'Subscription') this.HasCELines = true;
                if (ivd.ptp_code == 'Discount') {
                  this.AdditionalInvoiceDetails.push(new NetforumInvoiceDetails(ivd));
                } else {
                  this.InvoiceDetails.push(new NetforumInvoiceDetails(ivd));
                }
              });
              break;
            case 'AdditionalInvoiceDetails':
              source.AdditionalInvoiceDetails.forEach(ivd => {
                this.AdditionalInvoiceDetails.push(new NetforumInvoiceDetails(ivd));
              });
              break;
            default:
              if (source[key] != null) {
                this[key] = source[key];
              }
          }
        }
      }
    }
  }
}
class NetforumInvoiceDetails {
  constructor(source) {
    this.ivd_key = undefined;
    this.ivd_price = undefined;
    this.ivd_discountamount = undefined;
    this.ivd_total = undefined;
    this.ptp_code = undefined;
    this.prc_code = undefined;
    this.prc_display_name = undefined;
    if (source) {
      for (const key in this) {
        if (key in source) {
          switch (key) {
            default:
              if (source[key] != null) {
                this[key] = source[key];
              }
          }
        }
      }
    }
  }
}
class ShoppingCartItem {
  constructor(type, courseId, cartIvdObject) {
    this.type = type;
    this.itemId = courseId;
    this.ivdKey = cartIvdObject.ivd_key;
    this.prcKey = cartIvdObject.prc_key;
    this.prdName = cartIvdObject.prc_display_name;
    this.prdKey = cartIvdObject.prd_key;
    this.price = cartIvdObject.ivd_price;
  }
  get ItemID() {
    return this.itemId;
  }
  get Type() {
    return this.type;
  }
  get IvdKey() {
    return this.ivdKey;
  }
  get PriceKey() {
    return this.prcKey;
  }
  get ProductName() {
    return this.prdName;
  }
  get ProductKey() {
    return this.prdKey;
  }
  get Price() {
    return this.price;
  }
  get Item() {
    return this.item;
  }
  SetItem(item) {
    this.item = item;
  }
}
class CourseFee {
  constructor(source) {
    this.cec_key = null;
    this.cec_id = null;
    this.cec_name = null;
    this.prd_key = null;
    this.prd_code = null;
    this.prd_name = null;
    this.prc_key = null;
    this.prc_code = null;
    this.prc_display_name = null;
    this.prc_price = null;
    if (source) {
      for (const key in this) {
        if (key in source) {
          switch (key) {
            default:
              this[key] = source[key];
          }
        }
      }
    }
  }
}
class SSOService {
  constructor(httpClient, LmsAppSettings) {
    this.httpClient = httpClient;
    this.LmsAppSettings = LmsAppSettings;
  }
  RefreshSSO() {
    return this.httpClient.get(this.LmsAppSettings.apiBaseURL + 'sso');
  }
  GetWithSSORefresh(url) {
    return this.httpClient.get(url).pipe(catchError(() => {
      return this.RefreshSSO().pipe(switchMap(sso => {
        return this.httpClient.get(url);
      }));
    }));
  }
  static {
    this.ɵfac = function SSOService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SSOService)(i0.ɵɵinject(i1$1.HttpClient), i0.ɵɵinject(LmsAppSettings));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: SSOService,
      factory: SSOService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SSOService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: i1$1.HttpClient
  }, {
    type: LmsAppSettings
  }], null);
})();
class CourseFeeService {
  constructor(httpClient, ssoService, LmsAppSettings) {
    this.httpClient = httpClient;
    this.ssoService = ssoService;
    this.LmsAppSettings = LmsAppSettings;
    this.priceKeyToCourse = new Map();
    this.priceKeyToBundle = new Map();
  }
  FetchFee(courseId) {
    return this.ssoService.GetWithSSORefresh(this.LmsAppSettings.pac_base_nf_url + "api/CourseFee?cec_id=" + courseId).pipe(map(result => {
      if (!Array.isArray(result) || result.length == 0) {
        return new CourseFee({});
      }
      result.sort((a, b) => a.prc_price - b.prc_price);
      let feeObj = new CourseFee(result[0]);
      if (!this.priceKeyToCourse.has(feeObj.prc_key)) {
        this.priceKeyToCourse.set(feeObj.prc_key, feeObj.cec_id);
      }
      return feeObj;
    }));
  }
  FetchBundleFee(bundleId) {
    return this.ssoService.GetWithSSORefresh(this.LmsAppSettings.pac_base_nf_url + "api/Cart/pc_su_subscription_list/" + bundleId).pipe(map(result => {
      if (Array.isArray(result) && result.length > 0) {
        let feeObj = new CourseFee(result[0]);
        if (!this.priceKeyToBundle.has(feeObj.prc_key)) {
          this.priceKeyToBundle.set(feeObj.prc_key, feeObj.cec_id);
        }
        return feeObj;
      }
    }));
  }
  GetCourseFromPriceKey(priceKey) {
    return this.priceKeyToCourse.get(priceKey);
  }
  GetFees() {
    return of(new Map());
  }
  GetFee(courseId) {
    return of(new CourseFee({}));
  }
  static {
    this.ɵfac = function CourseFeeService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || CourseFeeService)(i0.ɵɵinject(i1$1.HttpClient), i0.ɵɵinject(SSOService), i0.ɵɵinject(LmsAppSettings));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: CourseFeeService,
      factory: CourseFeeService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CourseFeeService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: i1$1.HttpClient
  }, {
    type: SSOService
  }, {
    type: LmsAppSettings
  }], null);
})();
class UserCourseFeeService {
  constructor(userService, feeService) {
    this.userService = userService;
    this.feeService = feeService;
    this.lastUID = 0;
    this.userFees = new Map();
    this.bundleFees = new Map();
    this.UserFees$ = new ReplaySubject();
    this.userService.OnUserStateChange.subscribe(user => {
      if (this.lastUID != user.ID) {
        this.lastUID = user.ID;
        this.userFees.clear();
      }
    });
  }
  getBundleFeesForPriceKeys(priceKeys) {
    let allFees$ = [];
    priceKeys.forEach(priceKey => {
      allFees$.push(this.GetBundleFee(priceKey));
    });
    return of(null);
  }
  GetCourseFee(courseIdOrPriceKey) {
    if (!this.userService.IsLoggedIn || courseIdOrPriceKey == undefined) {
      return of(null);
    }
    let courseId = courseIdOrPriceKey;
    if (courseIdOrPriceKey.match(/^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i)) {
      courseId = this.GetCourseFromPriceKey(courseIdOrPriceKey);
    }
    if (this.userFees.has(courseId)) {
      return of(this.userFees.get(courseId));
    }
    return this.feeService.FetchFee(courseId).pipe(tap(fee => {
      this.userFees.set(courseId, fee);
    }));
  }
  GetBundleFee(bundleId) {
    if (!this.userService.IsLoggedIn) {
      return of(null);
    }
    if (this.bundleFees.has(bundleId)) {
      return of(this.bundleFees.get(bundleId));
    }
    return this.feeService.FetchBundleFee(bundleId).pipe(tap(fee => {
      this.bundleFees.set(bundleId, fee);
      return fee;
    }));
  }
  GetCourseFromPriceKey(priceKey) {
    return this.feeService.GetCourseFromPriceKey(priceKey);
  }
  static {
    this.ɵfac = function UserCourseFeeService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || UserCourseFeeService)(i0.ɵɵinject(LmsUserService), i0.ɵɵinject(CourseFeeService));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: UserCourseFeeService,
      factory: UserCourseFeeService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(UserCourseFeeService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: LmsUserService
  }, {
    type: CourseFeeService
  }], null);
})();
class ShoppingCartService {
  constructor(httpClient, userFeeService, ssoService, LmsAppSettings) {
    this.httpClient = httpClient;
    this.userFeeService = userFeeService;
    this.ssoService = ssoService;
    this.LmsAppSettings = LmsAppSettings;
    this._cartbeat = interval(5 * 60 * 1000);
    this._cartLoaded = false;
    this._hasPaymentMethod = false;
    this._freeCart = new CartDetails();
    this._paidCart = new CartDetails();
    this.CartDetails = new ReplaySubject();
    this.SSORefreshRequired = new ReplaySubject();
    this.userFeeService.UserFees$.subscribe(fees => {
      this.RefreshCart().subscribe();
    });
    this._paidCart.PendingItems.add("InitialLoad");
    this.RefreshCart().subscribe();
    this._cartbeat.subscribe(t => {
      this.CartHeartbeat();
    });
  }
  get CartLoaded() {
    return this._cartLoaded;
  }
  CartHeartbeat() {
    if (this.LmsAppSettings.CartHeartbeatDisabled !== true) {
      this.ssoService.GetWithSSORefresh(this.LmsAppSettings.pac_base_nf_url + 'api/Cart/Get?cart=paid').subscribe();
    } else {
      console.warn("Cart heartbeat disabled");
    }
  }
  populateCartItemList(cart, cartId) {
    let cartDetails = cartId == 'free' ? this._freeCart : this._paidCart;
    cartDetails.Discounts = [];
    cartDetails.Courses.clear();
    cartDetails.Subscriptions.clear();
    cartDetails.Subtotal = cart.inv_total;
    cartDetails.Discount = cart.inv_discount;
    cartDetails.Total = cart.inv_nettotal;
    if (Array.isArray(cart.AdditionalInvoiceDetails) && cart.AdditionalInvoiceDetails.length >= 1) {
      cart.AdditionalInvoiceDetails.forEach(ivd => {
        cartDetails.Discounts.push(new NetforumInvoiceDetails(ivd));
      });
    }
    let coursePriceKeys = [];
    let ivdByPriceKey = new Map();
    if (cart.InvoiceDetails) {
      cart.InvoiceDetails.forEach(ivd => {
        switch (ivd.ptp_code) {
          case 'Course Fee':
            cart.CourseParticipants.forEach(cup => {
              if (cup.ProductKeys.includes(ivd.prd_key)) {
                cartDetails.Courses.set(cup.cec_id, new ShoppingCartItem('Course', cup.cec_id, ivd));
              }
            });
            break;
          case 'Subscription':
            cartDetails.Subscriptions.set(ivd.prd_code, new ShoppingCartItem('Subscription', ivd.prd_code, ivd));
            break;
        }
        ivdByPriceKey.set(ivd.prc_key, ivd);
      });
    }
    this._cartLoaded = true;
    cartDetails.PendingItems.delete("InitialLoad");
    if (cartId == 'paid') {
      this._paidCart = cartDetails;
      this.CartDetails.next(this._paidCart);
    } else if (cartId == 'free') {
      this._freeCart = cartDetails;
    }
    return of(cartDetails);
  }
  ClearCart(cartId = "paid") {
    return this.ssoService.GetWithSSORefresh(this.LmsAppSettings.pac_base_nf_url + 'api/Cart/New?cart=' + cartId).pipe(switchMap(cart => {
      return this.populateCartItemList(cart, cartId);
    }));
  }
  RefreshCart(cartId = "paid") {
    return this.ssoService.GetWithSSORefresh(this.LmsAppSettings.pac_base_nf_url + 'api/Cart/Get?cart=' + cartId).pipe(switchMap(cart => {
      return this.populateCartItemList(cart, cartId);
    }));
  }
  RefreshRawCart(cartId = "paid") {
    return this.ssoService.GetWithSSORefresh(this.LmsAppSettings.pac_base_nf_url + 'api/Cart/Get?cart=' + cartId);
  }
  GetPurchasePrice(courseId) {
    return this.userFeeService.GetCourseFee(courseId).pipe(map(fee => {
      return get(fee, 'prc_price', null);
    }));
  }
  get CartItemCount() {
    return this._paidCart.Courses.size + this._paidCart.Subscriptions.size;
  }
  IsItemInCart(item) {
    return this._paidCart.Courses.has(item) || this._paidCart.Subscriptions.has(item);
  }
  get PendingUpdate() {
    return this._paidCart.PendingItems.size > 0;
  }
  get PendingItems() {
    return this._paidCart.PendingItems;
  }
  AddCourse(courseId) {
    this._paidCart.PendingItems.add(courseId);
    return this.userFeeService.GetCourseFee(courseId).pipe(switchMap(courseFee => {
      let data = {
        cec_key: courseFee.cec_key
      };
      let cartId = courseFee.prc_price == 0 ? 'free' : 'paid';
      if (cartId == 'free') {
        this._paidCart.PendingItems.delete(courseId);
      }
      return this.RefreshCart(cartId).pipe(switchMap(cart => {
        return this.httpClient.post(this.LmsAppSettings.pac_base_nf_url + 'api/Cart/CourseParticipants/' + courseFee.prc_key + '?dupeCheck=true&cart=' + cartId, data);
      }), catchError(err => {
        if (err instanceof HttpErrorResponse && get(err, 'status', 0) == 409 && get(err, 'error.code', null) == "course-exists") {
          throw new DuplicateCourseParticipantException();
        } else {
          throw new AddCourseFailedException();
        }
      }), switchMap(cart => {
        this._paidCart.PendingItems.delete(courseId);
        return this.populateCartItemList(cart, cartId);
      }));
    }));
  }
  RemoveCourse(itemId) {
    this._paidCart.PendingItems.add(itemId);
    return this.RefreshCart().pipe(switchMap(cart => {
      let item = this._paidCart.Courses.get(itemId);
      if (item) {
        let ivdKey = item.IvdKey;
        let cartId = 'paid';
        return this.httpClient.delete(this.LmsAppSettings.pac_base_nf_url + 'api/Cart/InvoiceDetails/' + ivdKey + '?cart=' + cartId);
      }
      return of(cart);
    }), switchMap(cart => {
      this._paidCart.PendingItems.delete(itemId);
      return this.populateCartItemList(cart, 'paid');
    }));
  }
  AddBundle(itemId) {
    this._paidCart.PendingItems.add(itemId);
    return this.userFeeService.GetBundleFee(itemId).pipe(switchMap(fee => {
      return this.RefreshCart('paid').pipe(switchMap(cart => {
        return this.httpClient.put(this.LmsAppSettings.pac_base_nf_url + 'api/Cart/Subscription/' + fee.prc_key + '?cart=paid', {});
      }), switchMap(sub => {
        return this.RefreshRawCart('paid');
      }), switchMap(cart => {
        this._paidCart.PendingItems.delete(itemId);
        return this.populateCartItemList(cart, 'paid');
      }));
    }));
  }
  RemoveBundle(itemId) {
    this._paidCart.PendingItems.add(itemId);
    return this.RefreshCart().pipe(switchMap(cart => {
      let item = this._paidCart.Subscriptions.get(itemId);
      if (item) {
        let ivdKey = item.IvdKey;
        let cartId = 'paid';
        return this.httpClient.delete(this.LmsAppSettings.pac_base_nf_url + 'api/Cart/InvoiceDetails/' + ivdKey + '?cart=' + cartId);
      }
      return of(cart);
    }), switchMap(cart => {
      this._paidCart.PendingItems.delete(itemId);
      return this.populateCartItemList(cart, 'paid');
    }));
  }
  SetPayment(cpiKey, apmKey) {
    let cartId = 'paid';
    const observable = this.httpClient.put(this.LmsAppSettings.pac_base_nf_url + 'api/Cart/UpdatePayment?type=prepaid&cart=' + cartId, {
      pin_cpi_key: cpiKey,
      pin_apm_key: apmKey
    }).pipe(tap(() => {
      this._hasPaymentMethod = true;
    }));
    return observable;
  }
  SetPromoCode(promoCode) {
    let cartId = 'paid';
    const observable = this.httpClient.post(this.LmsAppSettings.pac_base_nf_url + 'api/Cart/ApplyMemberDiscount?promo=' + promoCode + '&cart=' + cartId, {}).pipe(switchMap(cart => {
      return this.populateCartItemList(cart, cartId);
    }));
    return observable;
  }
  Checkout(cartId = "paid") {
    if (!this._hasPaymentMethod && this._paidCart.Total > 0) {
      throw new MissingPaymentMethodException();
    }
    return this.httpClient.post(this.LmsAppSettings.pac_base_nf_url + 'api/Cart/Checkout?cart=' + cartId, {
      inv_send_email_confirmation: this._paidCart.Total > 0
    }).pipe(catchError(err => {
      throw new CheckoutException();
    }), tap(() => {
      this._hasPaymentMethod = false;
      this.SSORefreshRequired.next(null);
    }), switchMap(cart => {
      return this.populateCartItemList(cart, cartId);
    }));
  }
  static {
    this.ɵfac = function ShoppingCartService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ShoppingCartService)(i0.ɵɵinject(i1$1.HttpClient), i0.ɵɵinject(UserCourseFeeService), i0.ɵɵinject(SSOService), i0.ɵɵinject(LmsAppSettings));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: ShoppingCartService,
      factory: ShoppingCartService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ShoppingCartService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: i1$1.HttpClient
  }, {
    type: UserCourseFeeService
  }, {
    type: SSOService
  }, {
    type: LmsAppSettings
  }], null);
})();
class SQSService {
  constructor(httpClient, LmsAppSettings) {
    this.httpClient = httpClient;
    this.LmsAppSettings = LmsAppSettings;
  }
  AddQuiz(messageGroupId, body) {
    let postData = {
      'Action': 'SendMessage',
      'MessageAttribute.1.Name': 'Action',
      'MessageAttribute.1.Value.DataType': 'String',
      'MessageAttribute.1.Value.StringValue': 'AddQuiz',
      'MessageBody': body,
      'MessageGroupId': messageGroupId,
      'QueueUrl': this.LmsAppSettings.SQSSendUrl,
      'Version': '2012-11-05'
    };
    let sqsBaseUrl = this.LmsAppSettings.SQSSendUrl.substring(0, this.LmsAppSettings.SQSSendUrl.indexOf('/', 10) + 1);
    let postBody = new URLSearchParams(postData).toString();
    return this.httpClient.post(sqsBaseUrl, postBody, {
      "headers": {
        'Content-Type': "application/x-www-form-urlencoded; charset=UTF-8"
      }
    });
  }
  static {
    this.ɵfac = function SQSService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SQSService)(i0.ɵɵinject(i1$1.HttpClient), i0.ɵɵinject(LmsAppSettings));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: SQSService,
      factory: SQSService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SQSService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: i1$1.HttpClient
  }, {
    type: LmsAppSettings
  }], null);
})();
class UserCourseDataService {
  constructor(httpClient, sqsService, userService, dataService, messageBrokerService, shoppingCartService, LmsAppSettings) {
    this.httpClient = httpClient;
    this.sqsService = sqsService;
    this.userService = userService;
    this.dataService = dataService;
    this.messageBrokerService = messageBrokerService;
    this.shoppingCartService = shoppingCartService;
    this.LmsAppSettings = LmsAppSettings;
    this._courses = [];
    this._courseData = new Map();
    this._bundles = new Map();
    this._restrictedCourseData = new Map();
    this.User = new ReplaySubject();
    this.Courses$ = new ReplaySubject();
    this.Bundles$ = new ReplaySubject();
    this.LoggedIn$ = new ReplaySubject();
    this.userService.OnUserStateChange.subscribe(user => {
      if (user.ID == 0) {
        this._bundles.clear();
        this.Bundles$.next([]);
        this._courseData.clear();
        this._restrictedCourseData.clear();
        this._courses.forEach(course => {
          course.ClearRestrictedData();
        });
        this.SetCourseData();
      }
      this.LoggedIn$.next(user.ID > 0);
      this.User.next(user);
    });
    combineLatest([dataService.OnCoursesUpdated, dataService.OnBundlesUpdated, userService.OnUserStateChange]).subscribe(([courses, bundles, user]) => {
      if (bundles) {
        let visibleBundles = [];
        bundles.forEach(bundle => {
          if (user.Subscriptions.has(bundle.product_code)) {
            bundle.Access = true;
            bundle.Expires = user.Subscriptions.get(bundle.product_code).trm_end_date;
          }
          if (user.Events.has(bundle.product_code)) {
            bundle.Access = true;
          }
          if (bundle.can_be_purchased || bundle.Access) visibleBundles.push(bundle);
        });
        this.Bundles$.next(visibleBundles);
      }
      if (user.FullSSOData && user.FullSSOData.pac_lms) {
        this.SetCourseData(courses, user.FullSSOData.pac_lms);
      } else {
        this.SetCourseData(courses);
      }
    });
    this.shoppingCartService.SSORefreshRequired.subscribe(() => {
      this.RefreshSSOData();
    });
    setInterval(() => this.PollPendingCourses(), 30000);
  }
  RefreshSSOData() {
    this._restrictedCourseData.clear();
    this.httpClient.get(this.LmsAppSettings.apiBaseURL + 'sso').pipe(tap(ssoResponse => {
      this.userService.GetUserInfo(ssoResponse);
    })).subscribe();
  }
  get IsLoggedIn() {
    return this.userService.IsLoggedIn;
  }
  GetCourseData(courseId) {
    return this._courseData.get(courseId) || {};
  }
  SetCourseData(courses, lmsData) {
    if (courses) {
      this._courses = courses;
    }
    if (lmsData && lmsData.courses) {
      Object.keys(lmsData.courses).forEach(courseId => {
        this._courseData.set(courseId, new UserCourseDetail(lmsData.courses[courseId]));
      });
    }
    if (this.userService.User.Roles.length == 0) {
      this.userService.User.Roles.push("anonymous");
    }
    let accessibleCourses = new Map();
    this._courses.forEach(course => {
      course.userData = this._courseData.has(course.netforum_course_id) ? this._courseData.get(course.netforum_course_id) : new UserCourseDetail();
      if (this._courseData.get(course.netforum_course_id) && this._courseData.get(course.netforum_course_id).Status == 'CE Earned') {
        accessibleCourses.set(course.netforum_course_id, course);
        return;
      }
      this.userService.User.Roles.forEach(role => {
        if (course.permissions.roles[role] != null && course.permissions.roles[role] != 'none') {
          accessibleCourses.set(course.netforum_course_id, course);
          return;
        }
      });
    });
    this.Courses$.next(Array.from(accessibleCourses.values()));
  }
  get Carousels() {
    return this.dataService.OnCarouselsUpdated;
  }
  get Favorites() {
    let favoriteCourses = [];
    this._courseData.forEach((courseData, courseId) => {
      if (courseData.Favorite) favoriteCourses.push(courseId);
    });
    return favoriteCourses;
  }
  get HasPaidCourses() {
    return this._courses.filter(c => c.userData.Paid).length > 0;
  }
  GetCertificateURL(course = null) {
    if (!this.userService.IsLoggedIn || !this.userService.User.FullSSOData) return;
    let url = this.LmsAppSettings.siteBaseURL + 'lms-certificate/';
    url += this.userService.User.FullSSOData.pac_sso.CurrentKey + '/';
    url += course ? course.netforum_course_id : "";
    return url;
  }
  PollPendingCourses() {
    if (!this.userService.IsLoggedIn) return;
    let coursesToPoll = [];
    this._courseData.forEach((courseData, courseId) => {
      if (courseData.Status == 'CE Pending') {
        coursesToPoll.push(courseId);
      }
    });
    if (coursesToPoll.length == 0) return;
    this.httpClient.get(this.LmsAppSettings.apiBaseURL + 'api/lms/cupstatus/' + coursesToPoll.join(',')).pipe(tap(courses => {
      for (let courseId in courses) {
        let courseData = courses[courseId];
        if (courseData.Status == 'CE Earned') {
          this.SetCourseStatus(courseId, courseData.Status);
          let course = this._courses.find(course => course.netforum_course_id == courseId);
          this.messageBrokerService.AddInfoMessage("Certificate ready!", "Your CE certificate for " + course.title + " is now available!");
        }
      }
    })).subscribe();
  }
  Login(username, password) {
    return this.userService.Login(username, password);
  }
  Logout() {
    return this.userService.Logout();
  }
  GetRestrictedData(courseId) {
    if (this._restrictedCourseData.has(courseId)) {
      return of(this._restrictedCourseData.get(courseId));
    }
    return this.httpClient.get(this.LmsAppSettings.apiBaseURL + "api/lms/course/" + courseId).pipe(map(restrictedData => {
      this._restrictedCourseData.set(courseId, restrictedData);
      return restrictedData;
    }));
  }
  GetCourse(courseIdOrAlias) {
    let course$ = this.dataService.GetCourse(courseIdOrAlias);
    if (!this.userService.IsLoggedIn) {
      return course$;
    }
    return course$.pipe(switchMap(course => {
      return this.GetRestrictedData(course.netforum_course_id).pipe(map(restrictedData => {
        course.userData = this._courseData.has(course.netforum_course_id) ? this._courseData.get(course.netforum_course_id) : new UserCourseDetail();
        course.SetRestrictedData(restrictedData);
        return course;
      }));
    }));
  }
  StartCourse(course) {
    if (course.userData.Status != "Not Started") return of(course);
    return this.shoppingCartService.AddCourse(course.netforum_course_id).pipe(catchError(err => {
      if (err instanceof AddCourseFailedException) {
        this.messageBrokerService.AddErrorMessage("Course error", "We ran into a problem starting this course. Please try again in a few minutes.", 30);
        throw err;
      } else if (err instanceof DuplicateCourseParticipantException) {
        return of("SkipCheckout");
      } else {
        throw err;
      }
    }), switchMap(cart => {
      if (cart == 'SkipCheckout') {
        return of(course);
      }
      return this.shoppingCartService.Checkout('free');
    }), switchMap(cart => {
      return this.httpClient.post(this.LmsAppSettings.apiBaseURL + "api/lms/course/" + course.netforum_course_id + '/start', {});
    }), map(courseDetail => {
      return this.UpdateCourse(course.netforum_course_id, {
        Status: courseDetail.Status
      });
    }), catchError(err => {
      if (err instanceof AddCourseFailedException) {
        return of(course);
      } else {
        throw err;
      }
    }));
  }
  ActivateCE(course) {
    return this.httpClient.post(this.LmsAppSettings.apiBaseURL + "api/lms/course/" + course.netforum_course_id + '/activate', {}).pipe(map(courseDetail => {
      return this.UpdateCourse(course.netforum_course_id, {
        Status: courseDetail.Status
      });
    }));
  }
  FavoriteCourse(courseId) {
    let newValue = !get(this._courseData.get(courseId), 'Favorite', false);
    this.httpClient.post(this.LmsAppSettings.apiBaseURL + "api/lms/course/" + courseId + '/favorite', {
      favorite: newValue
    }).pipe(map(course => {
      this.UpdateCourse(courseId, {
        Favorite: course.Favorite
      });
    })).subscribe();
  }
  SetCourseStatus(courseId, status) {
    this.UpdateCourse(courseId, {
      Status: status
    });
  }
  SetPosition(courseId, time) {
    if (time == 0) return;
    this.httpClient.post(this.LmsAppSettings.apiBaseURL + "api/lms/course/" + courseId + '/position', {
      time: time
    }).pipe(map(course => this.UpdateCourse(courseId, {
      Position: course.Position,
      Status: course.Status
    }))).subscribe();
  }
  UpdateCourse(courseId, newData) {
    let courseData = this._courseData.get(courseId) || new UserCourseDetail();
    for (const field in newData) {
      courseData[field] = newData[field];
    }
    this._courseData.set(courseId, courseData);
    this.SetCourseData();
    return this._courses.find(course => course.netforum_course_id == courseId);
  }
  SubmitEvaluation(courseId, answers) {
    this.httpClient.post(this.LmsAppSettings.apiBaseURL + "api/lms/course/" + courseId + "/evaluate", answers).pipe(map(course => this.UpdateCourse(courseId, {
      Evaluated: course.Evaluated
    }))).subscribe();
  }
  SubmitQuiz(courseId, answers, score, passed) {
    if (score == null) return;
    let sqsBody = {
      cst_key: this.userService.User.FullSSOData.pac_sso.CurrentKey,
      course: courseId,
      score: score,
      success: passed
    };
    let msgId = sqsBody.cst_key + sqsBody.course;
    if (passed) {
      sqsBody.issue_date = new Date();
    }
    let sqsPost$ = this.sqsService.AddQuiz(msgId, JSON.stringify(sqsBody));
    let drupalPost$ = this.httpClient.post(this.LmsAppSettings.apiBaseURL + "api/lms/course/" + courseId + "/quiz", answers).pipe(map(course => this.UpdateCourse(courseId, {
      Status: course.Status
    })));
    return combineLatest(sqsPost$, drupalPost$);
  }
  GetCourseBundles$(courseId) {
    return this.Bundles$.pipe(map(bundles => {
      return bundles.filter(b => b.courses.filter(c => c.netforum_course_id == courseId).length > 0);
    }));
  }
  static {
    this.ɵfac = function UserCourseDataService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || UserCourseDataService)(i0.ɵɵinject(i1$1.HttpClient), i0.ɵɵinject(SQSService), i0.ɵɵinject(LmsUserService), i0.ɵɵinject(LMSDataService), i0.ɵɵinject(MessageBrokerService), i0.ɵɵinject(ShoppingCartService), i0.ɵɵinject(LmsAppSettings));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: UserCourseDataService,
      factory: UserCourseDataService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(UserCourseDataService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: i1$1.HttpClient
  }, {
    type: SQSService
  }, {
    type: LmsUserService
  }, {
    type: LMSDataService
  }, {
    type: MessageBrokerService
  }, {
    type: ShoppingCartService
  }, {
    type: LmsAppSettings
  }], null);
})();
class LmsQuizService {
  constructor(httpClient, LmsAppSettings) {
    this.httpClient = httpClient;
    this.LmsAppSettings = LmsAppSettings;
    this.Cache = {
      Questions: {}
    };
  }
  GetQuestions(courseId) {
    if (this.Cache.Questions[courseId] && Array.isArray(this.Cache.Questions[courseId]) && this.Cache.Questions[courseId].length > 0) {
      return defer(() => of(this.Cache.Questions[courseId]));
    }
    return this.httpClient.get(this.LmsAppSettings.apiBaseURL + "api/lms/quiz/" + courseId).pipe(tap(result => {
      let cleanQuestions = [];
      result.forEach(question => {
        question.question = StripHtml(question.question);
        question.key = StripHtml(question.key);
        question.distractors.forEach((distractor, i) => {
          question.distractors[i] = StripHtml(distractor);
        });
      });
      this.Cache.Questions[courseId] = cleanQuestions;
    }));
  }
  static {
    this.ɵfac = function LmsQuizService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || LmsQuizService)(i0.ɵɵinject(i1$1.HttpClient), i0.ɵɵinject(LmsAppSettings));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: LmsQuizService,
      factory: LmsQuizService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LmsQuizService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: i1$1.HttpClient
  }, {
    type: LmsAppSettings
  }], null);
})();
class LoadIndicatorComponent {
  constructor() {}
  ngOnInit() {}
  static {
    this.ɵfac = function LoadIndicatorComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || LoadIndicatorComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: LoadIndicatorComponent,
      selectors: [["app-load-indicator"]],
      inputs: {
        description: "description"
      },
      decls: 2,
      vars: 2,
      consts: [["icon", "spinner", 1, "mr-2", 3, "spin"]],
      template: function LoadIndicatorComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelement(0, "fa-icon", 0);
          i0.ɵɵtext(1);
        }
        if (rf & 2) {
          i0.ɵɵproperty("spin", true);
          i0.ɵɵadvance();
          i0.ɵɵtextInterpolate1("Please wait while we ", ctx.description, "");
        }
      },
      dependencies: [i1.FaIconComponent]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LoadIndicatorComponent, [{
    type: Component,
    args: [{
      selector: 'app-load-indicator',
      template: "<fa-icon icon=\"spinner\" [spin]=\"true\" class=\"mr-2\"></fa-icon>Please wait while we {{description}}"
    }]
  }], () => [], {
    description: [{
      type: Input
    }]
  });
})();
class DynamicContentComponent {
  constructor(lmsContentService) {
    this.lmsContentService = lmsContentService;
    this.blocktitle = "";
    this.inline = false;
  }
  ngOnInit() {
    this.lmsContentService.GetContentBlock(this.blocktitle).subscribe(content => {
      this.baseContent = content;
      this.content = this.lmsContentService.ReplaceContentTokens(this.baseContent, this.parameters, this.inline);
    });
  }
  ngOnChanges(changes) {
    if (changes.parameters) {
      if (changes.parameters.previousValue != changes.parameters.currentValue) {
        if (this.content == null) {
          this.lmsContentService.GetContentBlock(this.blocktitle).subscribe(content => {
            this.baseContent = content;
            this.content = this.lmsContentService.ReplaceContentTokens(this.baseContent, this.parameters, this.inline);
          });
        } else {
          this.content = this.lmsContentService.ReplaceContentTokens(this.baseContent, this.parameters, this.inline);
        }
      }
    }
  }
  static {
    this.ɵfac = function DynamicContentComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DynamicContentComponent)(i0.ɵɵdirectiveInject(LMSContentService));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DynamicContentComponent,
      selectors: [["app-dynamic-content"]],
      inputs: {
        blocktitle: "blocktitle",
        parameters: "parameters",
        inline: "inline"
      },
      features: [i0.ɵɵNgOnChangesFeature],
      decls: 2,
      vars: 2,
      consts: [[4, "ngIf"], ["class", "htmlwidget", 4, "ngIf"], [3, "innerHTML", 4, "ngIf"], [3, "innerHTML"], [1, "htmlwidget"], ["description", "load this content"]],
      template: function DynamicContentComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, DynamicContentComponent_ng_container_0_Template, 3, 2, "ng-container", 0)(1, DynamicContentComponent_div_1_Template, 2, 0, "div", 1);
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", ctx.content !== null);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.content === null);
        }
      },
      dependencies: [i3.NgIf, LoadIndicatorComponent],
      styles: ["[_nghost-%COMP%]{display:block;max-width:100%;overflow:hidden}"]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DynamicContentComponent, [{
    type: Component,
    args: [{
      selector: 'app-dynamic-content',
      template: "<ng-container *ngIf=\"content !== null\">\r\n  <p *ngIf=\"!inline\" [innerHTML]=\"content\"></p>\r\n  <span *ngIf=\"inline\" [innerHTML]=\"content\"></span>\r\n</ng-container>\r\n<div class=\"htmlwidget\" *ngIf=\"content === null\">\r\n  <app-load-indicator description=\"load this content\"></app-load-indicator>\r\n</div>\r\n",
      styles: [":host{display:block;max-width:100%;overflow:hidden}\n"]
    }]
  }], () => [{
    type: LMSContentService
  }], {
    blocktitle: [{
      type: Input
    }],
    parameters: [{
      type: Input
    }],
    inline: [{
      type: Input
    }]
  });
})();
class CEQuizComponent {
  set courseid(value) {
    this.courseId$.next(value);
  }
  constructor(lmsQuizService, ucdService) {
    this.lmsQuizService = lmsQuizService;
    this.ucdService = ucdService;
    this.Passed$ = new EventEmitter();
    this.questions = [];
    this.courseId$ = new ReplaySubject(1);
    this.subsink = new SubSink();
    this.quizForm = new UntypedFormGroup({});
    this.quizPassed = null;
    this.submissionPending = false;
  }
  ngOnInit() {
    this.subsink.sink = this.ucdService.User.subscribe(user => this.submissionPending = false);
    this.subsink.sink = this.courseId$.subscribe({
      next: courseId => {
        this.questions = [];
        for (const key in this.quizForm.controls) {
          this.quizForm.removeControl(key);
        }
        this.ucdService.GetCourse(courseId).subscribe(course => {
          this.passPercent = course.pass_percentage;
          this.Passed$.emit(course.userData.Status == "CE Pending" || course.userData.Status == "CE Earned");
        });
        this.lmsQuizService.GetQuestions(courseId).subscribe(questions => questions.map(question => {
          let tmpAnswers = question.distractors;
          tmpAnswers.push(question.key);
          for (let i = tmpAnswers.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [tmpAnswers[i], tmpAnswers[j]] = [tmpAnswers[j], tmpAnswers[i]];
          }
          question.answers = [];
          for (let i = tmpAnswers.length - 1; i >= 0; i--) {
            question.answers[i] = {
              v: this.hashAnswer(tmpAnswers[i]),
              a: tmpAnswers[i]
            };
          }
          this.quizForm.addControl('q' + question.id, new UntypedFormControl());
          this.questions.push(question);
        }));
      }
    });
  }
  ngOnDestroy() {
    this.subsink.unsubscribe();
  }
  setAnswer(question, answer) {
    if (this.quizForm.controls['q' + question].value == answer) {
      this.quizForm.controls['q' + question].setValue(null);
    } else {
      this.quizForm.controls['q' + question].setValue(answer);
    }
  }
  submitQuiz(courseId, quizForm) {
    let correct = 0;
    let answers = {};
    for (let q = 0; q < this.questions.length; q++) {
      answers[this.questions[q].question] = false;
      if (quizForm.value['q' + this.questions[q].id] == this.hashAnswer(this.questions[q].key)) {
        correct++;
        answers[this.questions[q].question] = true;
        this.questions[q].incorrect = false;
      } else {
        this.questions[q].incorrect = true;
      }
    }
    this.correctPercent = correct / this.questions.length * 100;
    this.quizPassed = this.correctPercent >= this.passPercent;
    this.submissionPending = true;
    this.Passed$.emit(this.quizPassed);
    this.ucdService.SubmitQuiz(courseId, answers, this.correctPercent, this.quizPassed).subscribe(() => {
      this.submissionPending = false;
      window.scrollTo(0, document.body.scrollHeight); //Make sure the message shows
    });
  }
  hashAnswer(answerString) {
    var hash = 0;
    if (answerString.length == 0) {
      return hash;
    }
    for (var i = 0; i < answerString.length; i++) {
      var char = answerString.charCodeAt(i);
      hash = (hash << 5) - hash + char;
      hash = hash & hash; // Convert to 32bit integer
    }
    return hash + 2147483648;
  }
  static {
    this.ɵfac = function CEQuizComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || CEQuizComponent)(i0.ɵɵdirectiveInject(LmsQuizService), i0.ɵɵdirectiveInject(UserCourseDataService));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: CEQuizComponent,
      selectors: [["app-cequiz"]],
      inputs: {
        courseid: "courseid"
      },
      outputs: {
        Passed$: "Passed$"
      },
      decls: 2,
      vars: 3,
      consts: [[3, "formGroup", "submit", 4, "ngIf"], [3, "submit", "formGroup"], ["class", "my-1 p-2", 3, "text-danger", 4, "ngFor", "ngForOf"], [3, "blocktitle", "parameters", 4, "ngIf"], [3, "blocktitle", 4, "ngIf"], ["class", "btn btn-success mb-5", 3, "disabled", 4, "ngIf"], [1, "my-1", "p-2"], ["tabindex", "0"], [1, "mb-2"], ["class", "mb-1", 4, "ngFor", "ngForOf"], [1, "mb-1"], ["type", "button", 1, "btn", "btn-block", "text-left", 3, "click"], ["type", "radio", "required", "", 3, "formControlName", "id", "value", "checked"], [1, "fa-lg", "unchecked", "mr-2", 3, "icon"], [1, "fa-lg", "checked", "mr-2", 3, "icon"], [3, "blocktitle", "parameters"], [3, "blocktitle"], [1, "btn", "btn-success", "mb-5", 3, "disabled"]],
      template: function CEQuizComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, CEQuizComponent_form_0_Template, 5, 5, "form", 0);
          i0.ɵɵpipe(1, "async");
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 1, ctx.courseId$));
        }
      },
      dependencies: [i3.NgForOf, i3.NgIf, i4.ɵNgNoValidate, i4.DefaultValueAccessor, i4.RadioControlValueAccessor, i4.NgControlStatus, i4.NgControlStatusGroup, i4.RequiredValidator, i4.FormGroupDirective, i4.FormControlName, i1.FaIconComponent, DynamicContentComponent, i3.AsyncPipe],
      styles: ["[_nghost-%COMP%]   form[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]:hover{background-color:#d3d3d3;border-radius:.5em}input[type=radio][_ngcontent-%COMP%], .checked[_ngcontent-%COMP%]{display:none}input[type=radio][_ngcontent-%COMP%]:checked ~ .checked[_ngcontent-%COMP%]{display:inline-block}input[type=radio][_ngcontent-%COMP%]:checked ~ .unchecked[_ngcontent-%COMP%]{display:none}"]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CEQuizComponent, [{
    type: Component,
    args: [{
      selector: 'app-cequiz',
      template: "<form *ngIf=\"courseId$ | async as courseId\" [formGroup]=\"quizForm\" (submit)=\"submitQuiz(courseId, quizForm)\">\r\n  <div *ngFor=\"let question of questions; let q = index\" class=\"my-1 p-2\" [class.text-danger]=\"question.incorrect\">\r\n    <strong tabindex=\"0\">{{q + 1}}: {{question.question}}</strong>\r\n    <div class=\"d-flex flex-column\" class=\"mb-2\">\r\n      <div *ngFor=\"let answer of question.answers; let a = index\" class=\"mb-1\">\r\n        <button class=\"btn btn-block text-left\" (click)=\"setAnswer(question.id, answer.v)\" type=\"button\">\r\n            <input type=\"radio\" formControlName=\"q{{question.id}}\" id=\"q{{question.id}}a{{a}}\" value=\"{{answer.v}}\" required\r\n            [checked]=\"quizForm.get('q' + question.id).value == answer.v\" />\r\n            <fa-icon [icon]=\"['far','circle']\" class=\"fa-lg unchecked mr-2\"></fa-icon>\r\n            <fa-icon [icon]=\"['far','check-circle']\" class=\"fa-lg checked mr-2\"></fa-icon>\r\n          {{answer.a}}\r\n        </button>\r\n      </div>\r\n    </div>\r\n  </div>\r\n  <app-dynamic-content [blocktitle]=\"'CE Quiz Not Passed'\" *ngIf=\"quizPassed === false\" [parameters]=\"{score: correctPercent}\"></app-dynamic-content>\r\n  <app-dynamic-content [blocktitle]=\"'CE Quiz Passed'\" *ngIf=\"quizPassed === true\"></app-dynamic-content>\r\n  <button *ngIf=\"questions.length > 0\" class=\"btn btn-success mb-5\" [disabled]=\"quizForm.status!='VALID' || submissionPending\">{{submissionPending ? 'Submitting Quiz' : 'Submit Quiz'}}</button>\r\n</form>\r\n",
      styles: [":host form button:hover{background-color:#d3d3d3;border-radius:.5em}input[type=radio],.checked{display:none}input[type=radio]:checked~.checked{display:inline-block}input[type=radio]:checked~.unchecked{display:none}\n"]
    }]
  }], () => [{
    type: LmsQuizService
  }, {
    type: UserCourseDataService
  }], {
    courseid: [{
      type: Input
    }],
    Passed$: [{
      type: Output
    }]
  });
})();
class HtmlWidgetComponent {
  constructor(lmsContentService) {
    this.lmsContentService = lmsContentService;
    this.blocktitle = "";
  }
  ngOnInit() {
    this.lmsContentService.GetContentBlock(this.blocktitle).subscribe(content => {
      this.baseContent = content;
      this.content = this.lmsContentService.ReplaceContentTokens(this.baseContent, this.parameters);
    });
  }
  ngOnChanges(changes) {
    if (changes.parameters) {
      if (changes.parameters.previousValue != changes.parameters.currentValue) {
        if (this.content == null) {
          this.lmsContentService.GetContentBlock(this.blocktitle).subscribe(content => {
            this.baseContent = content;
            this.content = this.lmsContentService.ReplaceContentTokens(this.baseContent, this.parameters);
          });
        } else {
          this.content = this.lmsContentService.ReplaceContentTokens(this.baseContent, this.parameters);
        }
      }
    }
  }
  static {
    this.ɵfac = function HtmlWidgetComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || HtmlWidgetComponent)(i0.ɵɵdirectiveInject(LMSContentService));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: HtmlWidgetComponent,
      selectors: [["app-html-widget"]],
      inputs: {
        blocktitle: "blocktitle",
        parameters: "parameters"
      },
      features: [i0.ɵɵNgOnChangesFeature],
      decls: 2,
      vars: 2,
      consts: [[4, "ngIf"], ["class", "htmlwidget", 4, "ngIf"], [1, "htmlwidget", 3, "innerHTML"], [1, "htmlwidget"], ["description", "load this content"]],
      template: function HtmlWidgetComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, HtmlWidgetComponent_ng_container_0_Template, 2, 1, "ng-container", 0)(1, HtmlWidgetComponent_div_1_Template, 2, 0, "div", 1);
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", ctx.content !== null);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.content === null);
        }
      },
      dependencies: [i3.NgIf, LoadIndicatorComponent]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HtmlWidgetComponent, [{
    type: Component,
    args: [{
      selector: 'app-html-widget',
      template: "<ng-container *ngIf=\"content !== null\">\r\n  <div class=\"htmlwidget\" [innerHTML]=\"content\"></div>\r\n</ng-container>\r\n<div class=\"htmlwidget\" *ngIf=\"content === null\">\r\n  <app-load-indicator description=\"load this content\"></app-load-indicator>\r\n</div>\r\n"
    }]
  }], () => [{
    type: LMSContentService
  }], {
    blocktitle: [{
      type: Input
    }],
    parameters: [{
      type: Input
    }]
  });
})();
const lmsAppSettings = new LmsAppSettings();
class LmsApiModule {
  static forRoot() {
    return {
      ngModule: LmsApiModule,
      providers: [{
        provide: LmsAppSettings,
        useValue: lmsAppSettings
      }, {
        provide: HTTP_INTERCEPTORS,
        useClass: Interceptor,
        multi: true
      }, UserCourseDataService, SQSService, LMSContentService, LmsUserService, LMSDataService, MessageBrokerService, ShoppingCartService, InterceptorUserGatewayService, UserCourseDataService, SSOService]
    };
  }
  constructor(library) {
    let win = window;
    if ('MyMembership' in win && win.MyMembership) {
      if ('Settings' in win.MyMembership && win.MyMembership.Settings) {
        Object.assign(lmsAppSettings, win.MyMembership.Settings);
      }
    }
    library.addIcons(faMinus, faDollarSign, faShoppingCart, faSquare, faCheckSquare, faMinusSquare, faCircle, faCheckCircle, faCheck, faChevronCircleDown, faChevronCircleUp, faTh, faThList, faBookmark, faBookmark$1, faFileInvoice, faUser, faBars, faFilter, faCaretDown, faCaretUp, faUndo, faSpinner, faChevronRight, faChevronUp, faChevronDown, faCheck, faPlus, faQuestionCircle, faLevelUpAlt, faEllipsisH);
  }
  static {
    this.ɵfac = function LmsApiModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || LmsApiModule)(i0.ɵɵinject(i1.FaIconLibrary));
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: LmsApiModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      providers: [{
        provide: LmsAppSettings,
        useValue: lmsAppSettings
      }],
      imports: [CommonModule, FormsModule, ReactiveFormsModule, FontAwesomeModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LmsApiModule, [{
    type: NgModule,
    args: [{
      declarations: [CEQuizComponent, DynamicContentComponent, HtmlWidgetComponent, LoadIndicatorComponent],
      imports: [CommonModule, FormsModule, ReactiveFormsModule, FontAwesomeModule],
      exports: [CEQuizComponent, DynamicContentComponent, HtmlWidgetComponent, LoadIndicatorComponent],
      providers: [{
        provide: LmsAppSettings,
        useValue: lmsAppSettings
      }]
    }]
  }], () => [{
    type: i1.FaIconLibrary
  }], null);
})();
atatus$1.config('2146f4ec36034b268161609b5a6650ce', {
  allowedDomains: ['abmp.com', 'www.abmp.com'],
  ignoreErrors: [/Cannot find control with name: 'eval_.*/, /.*ZoneAwarePromise.*/, /.*ExpressionChangedAfterItHasBeenCheckedError.*/, /.*ChunkLoadError.*/, /.*AbortError.*/]
}).install();
atatus$1.setVersion('2.2.0');
atatus$1.setTags(['env:' + new LmsAppSettings().pac_base_nf_url]);
class AtatusErrorHandler {
  handleError(error) {
    if (atatus$1) {
      // Send the error to Atatus
      atatus$1.notify(error.originalError || error);
    }
  }
  static {
    this.ɵfac = function AtatusErrorHandler_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || AtatusErrorHandler)();
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: AtatusErrorHandler,
      factory: AtatusErrorHandler.ɵfac
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AtatusErrorHandler, [{
    type: Injectable
  }], null, null);
})();
class Author {}
class CEQuestion {}
class CourseSortDetail {
  constructor() {
    this.order = undefined;
    this.name = undefined;
    this.background = undefined;
  }
}

/*
 * Public API Surface of lms-api
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AddCourseFailedException, AtatusErrorHandler, Author, CEQuestion, CEQuizComponent, CartDetails, CheckoutException, Course, CourseBundle, CourseCarousel, CourseFee, CourseFeeService, CourseNotFoundException, CourseSortDetail, DuplicateCourseParticipantException, DynamicContentComponent, HtmlWidgetComponent, InterceptorUserGatewayService, LMSContentService, LMSDataService, LmsApiModule, LmsAppSettings, LmsQuizService, LmsUserService, LoadIndicatorComponent, Message, MessageBrokerService, MissingPaymentMethodException, NetforumInvoice, NetforumInvoiceDetails, SQSService, SSOService, ShoppingCartItem, ShoppingCartService, StripHtml, UserCourseDataService, UserCourseDetail, UserCourseFeeService, UserDetail };
